import { render, staticRenderFns } from "./MapViewPointCluster.vue?vue&type=template&id=05979466&"
var script = {}
import style0 from "./MapViewPointCluster.vue?vue&type=style&index=0&id=05979466&prod&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports